<div id="dialog-container">
  <h1 mat-dialog-title>{{ title | translate }}</h1>
  <mat-divider></mat-divider>
  @if (hideSpinner()) {
    <mat-stepper orientation="horizontal" [linear]="true">
      <ng-template matStepperIcon="edit">
        <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
      </ng-template>
      <mat-step [label]="'LABEL.CLIENT_NAME' | translate" [stepControl]="clientNameForm">
        <mat-dialog-content class="fx-flex-auto">
          <form [formGroup]="clientNameForm" novalidate>
            @if (!appManager.currentOrganization) {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'LABEL.ORGANIZATION' | translate }}</mat-label>
                <mat-select formControlName="organization" [id]="'client_organization_select'" [required]="true">
                  @for (organization of organizationsList; track organization.id) {
                    <mat-option [value]="organization.id">
                      {{ organization.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (clientNameForm.controls.organization.hasError('required')) {
                  <mat-error>
                    {{ 'ERROR.FIELD_REQUIRED' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            }
            <mat-form-field appearance="outline">
              <mat-label>{{ 'LABEL.CLIENT_NAME' | translate }}</mat-label>
              <input formControlName="clientName" [id]="'input_client_name'" [required]="true" matInput/>
              @if (clientNameForm.controls.clientName.hasError('required')) {
                <mat-error>
                  {{ 'ERROR.FIELD_REQUIRED' | translate }}
                </mat-error>
              }
              @if (clientNameForm.controls.clientName.hasError('maxlength')) {
                <mat-error>
                  {{ 'ERROR.FIELD_MAX_LENGTH' | translate:{value: appConfig.NAME_MAX_LENGTH} }}
                </mat-error>
              }
              @if (clientNameForm.controls.clientName.hasError('isValueTaken')) {
                <mat-error>
                  {{ 'ERROR.CLIENT_NAME_ALREADY_IN_USE' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button [id]="'client-cancel-button'" mat-stroked-button matDialogClose>
            {{ 'BUTTON.CANCEL' | translate }}
          </button>
          <button [disabled]="!clientNameForm.valid"
                  [id]="'client-next-button'"
                  color="accent"
                  mat-raised-button
                  matStepperNext>
            {{ 'BUTTON.NEXT' | translate }}
          </button>
        </mat-dialog-actions>
      </mat-step>
      <mat-step [label]="'LABEL.SUBSCRIPTION_CLIENT' | translate" [stepControl]="clientSubscriptionsForm">
        <mat-dialog-content class="fx-flex-auto">
          <form [formGroup]="clientSubscriptionsForm" novalidate>
            <div class="fx-layout-col">
              <div class="fx-layout-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'LABEL.CRM_CONTRACT_ID' | translate }}</mat-label>
                  <input formControlName="subscriptionContractId" [id]="'input_subscription_contract_id'" matInput/>
                  @if (clientSubscriptionsForm.controls.subscriptionContractId.hasError('maxlength')) {
                    <mat-error>
                      {{ 'ERROR.FIELD_MAX_LENGTH' | translate: {value: appConfig.CONTRACT_ID_MAX_LENGTH} }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="fx-layout-row fx-gap-10">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'LABEL.SUBSCRIPTION_START_DATE' | translate }}</mat-label>
                  <input (focus)="startDate.open()"
                         formControlName="subscriptionStart"
                         [id]="'input_subscription_start_date'"
                         [min]="minStartDate"
                         [matDatepicker]="startDate"
                         [required]="true"
                         matInput/>
                  <mat-datepicker-toggle [for]="startDate" matIconSuffix></mat-datepicker-toggle>
                  <mat-datepicker #startDate></mat-datepicker>
                  @if (clientSubscriptionsForm.controls.subscriptionStart.hasError('required')) {
                    <mat-error>
                      {{ 'ERROR.FIELD_REQUIRED' | translate }}
                    </mat-error>
                  }
                  @if (clientSubscriptionsForm.controls.subscriptionStart.hasError('matDatepickerMin')) {
                    <mat-error>
                      {{
                        'ERROR.FIELD_AFTER_DATE' | translate: {
                          value: clientSubscriptionsForm.controls.subscriptionStart
                            .getError('matDatepickerMin')['min']
                            .format(appConfig.DATE_FORMAT)
                        }
                      }}
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'LABEL.SUBSCRIPTION_END_DATE' | translate }}</mat-label>
                  <input (focus)="endDate.open()"
                         formControlName="subscriptionEnd"
                         [id]="'input_subscription_end_date'"
                         [min]="clientSubscriptionsForm.controls.subscriptionStart.value?.add(1, 'day')"
                         [matDatepicker]="endDate"
                         [required]="true"
                         matInput/>
                  <mat-datepicker-toggle [for]="endDate" matIconSuffix></mat-datepicker-toggle>
                  <mat-datepicker #endDate></mat-datepicker>
                  @if (clientSubscriptionsForm.controls.subscriptionEnd.hasError('required')) {
                    <mat-error>
                      {{ 'ERROR.FIELD_REQUIRED' | translate }}
                    </mat-error>
                  }
                  @if (clientSubscriptionsForm.controls.subscriptionEnd.hasError('matDatepickerMin')) {
                    <mat-error>
                      {{
                        'ERROR.FIELD_AFTER_DATE' | translate: {
                          value: clientSubscriptionsForm.controls.subscriptionEnd
                            .getError('matDatepickerMin')['min']
                            .format(appConfig.DATE_FORMAT)
                        }
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="fx-layout-row">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'LABEL.ACCOUNTS_AUTHORIZED' | translate }}</mat-label>
                  <input formControlName="subscriptionNbAuthorizedAccounts"
                         [id]="'input_subscription_nb_authorized_accounts'"
                         [required]="true"
                         matInput
                         min="0"
                         type="number"/>
                  @if (clientSubscriptionsForm.controls.subscriptionNbAuthorizedAccounts.hasError('required')) {
                    <mat-error>
                      {{ 'ERROR.FIELD_REQUIRED' | translate }}
                    </mat-error>
                  }
                  @if (clientSubscriptionsForm.controls.subscriptionNbAuthorizedAccounts.hasError('gt')) {
                    <mat-error>
                      {{ 'ERROR.MIN_VALUE' | translate:{value: 1} }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-list>
                  <h2 class="fx-layout-row fx-justify-start" mat-subheader>
                    <span class="fx-flex-30-percent">{{ 'LABEL.MODULES_SUBSCRIBED' | translate }}</span>
                    <span class="fx-flex-40-percent">{{ 'LABEL.NB_LICENCES_AUTHORIZED' | translate }}</span>
                    <span class="fx-flex-30-percent">{{ 'LABEL.ACCESS_LIMITED_DURATION' | translate }}</span>
                  </h2>
                  @for (moduleInfo of clientSubscriptionsForm.controls.subscriptionModules.controls;
                    track moduleInfo.value.moduleId; let i = $index) {
                    <mat-list-item
                      [id]="i" [formGroup]="moduleInfo">
                      <div class="subscription-row fx-layout-row fx-justify-start fx-align-center" matLine>
                        <div class="fx-flex-30-percent">
                          <mat-checkbox formControlName="active"
                                        [id]="'cb_module_' + moduleInfo.controls.moduleId.value "
                                        labelPosition="after">
                            {{ 'MODULE.' + moduleInfo.controls.name.value | translate }}
                          </mat-checkbox>
                        </div>
                        <div class="fx-flex-40-percent">
                          @if (moduleInfo.controls.isDefault.value) {
                            <div class="default-module fx-layout-row fx-justify-start fx-align-center">
                              {{ clientSubscriptionsForm.controls.subscriptionNbAuthorizedAccounts.value }}
                            </div>
                          } @else {
                            <mat-form-field appearance="fill">
                              <input formControlName="nbLicences" class="input_module_nb_licence"
                                     [max]="clientSubscriptionsForm.controls.subscriptionNbAuthorizedAccounts.value"
                                     [min]="1"
                                     [placeholder]="'LABEL.NB_LICENCES' | translate"
                                     [readonly]="!moduleInfo.controls.active.value"
                                     [required]="true" [step]="1"
                                     matInput
                                     min="0"
                                     type="number"/>
                              @if (moduleInfo.controls.nbLicences.hasError('required')) {
                                <mat-error>
                                  {{ 'ERROR.FIELD_REQUIRED' | translate }}
                                </mat-error>
                              }
                              @if (moduleInfo.controls.nbLicences.hasError('max')) {
                                <mat-error>
                                  {{
                                    'ERROR.FIELD_MAX_VALUE' | translate: {
                                      value:
                                      clientSubscriptionsForm.controls.subscriptionNbAuthorizedAccounts.value
                                    }
                                  }}
                                </mat-error>
                              }
                              @if (moduleInfo.controls.nbLicences.hasError('min')) {
                                <mat-error>
                                  {{ 'ERROR.MIN_VALUE' | translate: {value: 1} }}
                                </mat-error>
                              }
                            </mat-form-field>
                          }
                        </div>
                        <div class="fx-flex-offset-5-percent">
                          <mat-slide-toggle
                            [disabled]="!moduleInfo.controls.active.value || moduleInfo.controls.isDefault.value"
                            formControlName="limitedDuration">
                            @if (moduleInfo.controls.limitedDuration.value) {
                              <span> {{ 'LABEL.YES' | translate }}</span>
                            }
                            @if (!moduleInfo.controls.limitedDuration.value) {
                              <span>{{ 'LABEL.NO' | translate }}</span>
                            }
                          </mat-slide-toggle>
                        </div>
                      </div>
                    </mat-list-item>
                  }
                </mat-list>
              </div>
            </div>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button [id]="'client-subscription-cancel-button'" mat-stroked-button matDialogClose>
            {{ 'BUTTON.CANCEL' | translate }}
          </button>
          <button [id]="'client-subscription-previous-button'" mat-stroked-button matStepperPrevious>
            {{ 'BUTTON.PREVIOUS' | translate }}
          </button>
          <button [disabled]="!clientSubscriptionsForm.valid"
                  [id]="'save-button'"
                  color="accent"
                  mat-raised-button
                  matDialogClose="yes">
            {{ 'BUTTON.CREATE' | translate }}
          </button>
        </mat-dialog-actions>
      </mat-step>
    </mat-stepper>
  } @else {
    <spinner></spinner>
  }
</div>
